import {
  EntryCustomComponents,
} from '@o3r/components';
/**
 *
 */
export function registerCustomComponents(): Map<string, any> {
  return new Map<string, any>();
}

/**
 *
 */
export function initializeEntryComponents(): EntryCustomComponents {
  return {
    customComponents: [],
    customComponentsModules: []
  };
}
